import React from 'react';
import UserAuthScreen from './UserAuthScreen';

const LoginScreen = (props) => {
    const route = {
        ...props.route,
        params: {
            returnTo: 'Home',
            initialTab: 'login',
            ...(props.route?.params || {}),
        },
    };

    return <UserAuthScreen {...props} route={route} />;
};

export default LoginScreen;
